import { Modal } from "antd";
import React from "react";

export const BaseUploadModal = ({ open, setOpen, image, saveImage, handleImageChange, type, comment }) => {
    return <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
    >
        <div className="conteiner-modal-body-evidencias">
            <div>
                {image == null && (
                    <>
                        <div>
                            La imagen seleccionada debe estar en formato JPG y tener un
                            tamaño inferior a 1 MB
                        </div>
                        <label
                            htmlFor={`image-input-${type}`}
                            style={{
                                background: "#41b6e6", // Color de fondo
                                color: "#fff", // Color del texto
                                padding: "10px 15px", // Espaciado interno
                                borderRadius: "5px", // Borde redondeado
                                cursor: "pointer", // Cursor al pasar sobre el botón
                            }}
                        >
                            Seleccionar Imagen
                        </label>
                        <input
                            type="file"
                            onChange={handleImageChange}
                            accept=".jpg, .jpeg"
                            capture="user"
                            id={`image-input-${type}`} // Añade un ID al input
                            style={{
                                display: "none", // Oculta el input
                            }}
                        />
                    </>
                )}

                {image && (
                    <>
                        <div>
                            <img
                                src={image}
                                alt="Selected Image"
                                className="image-pick-recolecion"
                                style={{ width: '100%', marginBottom: '10px' }}
                            />
                        </div>
                        <div className="d-flex justify-content-center gap-3">
                            <div className="file-select" id="src-file1">
                                <input
                                    type="file"
                                    accept=".jpg, .jpeg"
                                    capture="user"
                                    onChange={handleImageChange}
                                    className="input-content-img"
                                />
                            </div>

                            <button
                                className="file-button-save"
                                style={{ background: "#c2185b", color: "#fff", padding: "10px", border: 'none', borderRadius: "5px" }}
                                onClick={saveImage}
                            >
                                Guardar
                            </button>
                        </div>
                        {comment &&
                            <>
                                <div>Comentario</div>
                                <div>{comment}</div>
                            </>
                        }
                    </>
                )}
            </div>
        </div>
    </Modal>
}